<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      class="control"
      label="药品通用名"
      labelWidth="100px"
      placeholder="请输入药品通用名"
      width="330px"
      v-model="drugName"
      prop="drugName"
      :input-attr="{ maxlength: 50 }"
      type="autocomplete"
      :query-search="querydrugName"
      clearable
      valueKey="drugName"
    />
    <label-input
      class="control"
      label="药品条形码"
      labelWidth="100px"
      placeholder="请输入药品条形码"
      width="330px"
      v-model="barCode"
      prop="barCode"
      :input-attr="{ maxlength: 50 }"
      clearable
      valueKey="barCode"
    />
    <label-input class="control" label="药品类型" width="230px" prop="secondaryClassify">
      <el-select v-model="secondaryClassify" placeholder="请选择状态">
        <el-option
          v-for="item in secondaryClassifyOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input class="control" label="状态" width="230px" prop="drugStatus">
      <el-select v-model="drugStatus" placeholder="请选择状态">
        <el-option
          v-for="item in drugStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <!-- <el-button class="search-btn" @click="search">查询</el-button> -->
  </search-wrapper>
</template>

<script>
import Fetch from '@/api';
import labelInput from '@/components/global/form/labelInputForSupervision';
import searchWrapper from '@/components/global/form/searchWrapper';

export default {
  name: 'searchBar',
  props: {
    searchParams: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    labelInput,
    searchWrapper
  },
  computed: {
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    barCode: {
      get() {
        return this.searchParams.barCode;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'barCode',
          value: val
        });
      }
    },
    secondaryClassify: {
      get() {
        return this.searchParams.secondaryClassify;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'secondaryClassify',
          value: val
        });
      }
    },
    drugStatus: {
      get() {
        return this.searchParams.drugStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugStatus',
          value: val
        });
      }
    },

    drugStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '启用', value: '1' },
        { label: '停用', value: '0' }
      ];
    },
    secondaryClassifyOptions() {
      return [
        { label: '全部', value: null },
        { label: '含麻', value: '4' },
        { label: '其他特殊药品', value: '3' }
      ];
    }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    querydrugName(queryString, cb) {
      const { storeId } = this;
      Fetch.getSupervisionSpecialCatalogueList({ drugName: queryString, storeId, pageNo: 1, pageSize: 30 }).then(
        ({ data }) => {
          cb(data);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  // .control {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  .zy-date-picker {
    margin-right: 16px;
    margin-bottom: 10px;
  }

  .search-btn {
    margin-bottom: 10px;
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }

  /deep/.date-picker {
    border: unset;
    padding-right: 0;
  }
}
</style>
